import React from "react"
import { Route, Redirect } from "react-router-dom"
import { useAuth } from '../../contexts/AuthContext'

export default function BecarioRoute({ component: Component, ...rest }) {
  const { currentUser,currentBecario,currentAdmin } = useAuth()

  console.log(currentAdmin+currentBecario)


  return (
    <Route
      {...rest}
      render={props => {
        return (currentAdmin===true || currentBecario===true) ? (
          currentUser? <Component {...props} /> : <Redirect to="/login" />
        ) :
        (        
        <> 
          <div>
            <h1>Solo para becarios</h1>
          </div>                  
        </>)
      }}
    ></Route>
  )
}
